import React from 'react';

// Levels are positions in the flow, not statuses: one neutral chip.
const LEVEL_CHIP_CLASS = 'bg-surface-sunken text-ink-secondary';

export interface OverviewBulletsPanelProps {
  title: string;
  bullets: string[];
  /** One level label per bullet, in the same order. */
  labels: readonly string[];
}

/**
 * The five-level overview at the top of an insights Summary: one short bullet
 * per level, each tagged with its level. Shared by post-call insights
 * ("Call Overview") and training insights ("Session Overview").
 */
export const OverviewBulletsPanel: React.FC<OverviewBulletsPanelProps> = ({ title, bullets, labels }) => (
  <div className="bg-white border border-hairline rounded-xl shadow-sm p-4 mb-4">
    <p className="text-xs font-bold text-ink-muted uppercase tracking-widest mb-3">{title}</p>
    <div className="space-y-2.5">
      {bullets.map((bullet, idx) => (
        <div key={idx} className="flex items-start gap-2.5">
          {labels[idx] && (
            <span className={`text-[10px] font-bold px-2 py-0.5 rounded flex-shrink-0 mt-0.5 ${LEVEL_CHIP_CLASS}`}>
              {labels[idx]}
            </span>
          )}
          <p className="text-sm text-ink-secondary leading-relaxed">{bullet}</p>
        </div>
      ))}
    </div>
  </div>
);

export default OverviewBulletsPanel;
